export default "__VITE_PUBLIC_ASSET__035f5bc4__"